module.exports = __webpack_public_path__ + "media/entities/1401-89e200fd.png";